export type SpreedlyResponse = {
  saveCardDetails: boolean;
  spreedlyResponse: {
    token: string;
    fingerprint: string;
  };
  token: string;
};

export enum SPREEDLY_CHALLENGE_STATES {
  'NEUTRAL',
  'LOADING',
  'SUCCESS',
  'TIMEOUT_ERROR',
  'PROCESSING_ERROR',
}
